// Parsed by hand rather than with zod: this module loads on every page, and zod is only needed by forms.
const raw = import.meta.env;

function flag(value: unknown, name: string, fallback = false): boolean {
  if (value === undefined || value === "") return fallback;
  if (value === "false") return false;
  if (value === "true") return true;
  throw new Error(
    `Invalid environment configuration:\n${name}: expected "true" or "false", got "${String(value)}"`,
  );
}

function positiveInt(value: unknown, fallback: number, name: string): number {
  if (value === undefined || value === "") return fallback;
  const n = Number(value);
  if (!Number.isInteger(n) || n < 1) {
    throw new Error(
      `Invalid environment configuration:\n${name}: expected a positive integer, got "${String(value)}"`,
    );
  }
  return n;
}

function apiBase(value: unknown): string {
  const v = value === undefined || value === "" ? "/api/v1" : String(value);
  if (!v.startsWith("/")) {
    throw new Error(
      `Invalid environment configuration:\nVITE_API_BASE_URL: must be a same-origin path such as /api/v1, got "${v}"`,
    );
  }
  return v;
}

export const env = {
  VITE_API_BASE_URL: apiBase(raw.VITE_API_BASE_URL),
  VITE_FEATURE_SHARING: flag(raw.VITE_FEATURE_SHARING, "VITE_FEATURE_SHARING", true),
  /** Files at or above this size use chunked upload. A dev knob until the backend exposes GET /config. */
  VITE_UPLOAD_CHUNK_THRESHOLD_MB: positiveInt(
    raw.VITE_UPLOAD_CHUNK_THRESHOLD_MB,
    32,
    "VITE_UPLOAD_CHUNK_THRESHOLD_MB",
  ),
  VITE_SENTRY_DSN: raw.VITE_SENTRY_DSN ? String(raw.VITE_SENTRY_DSN) : undefined,
  /** Optional endpoint that receives Web Vitals in production. Same-origin path or absolute URL. */
  VITE_VITALS_URL: raw.VITE_VITALS_URL ? String(raw.VITE_VITALS_URL) : undefined,
} as const;

export const features = { sharing: env.VITE_FEATURE_SHARING } as const;
